import { useState, useEffect } from "react"
import { Typography, Button, Card, CardContent, FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, Divider, Box, Alert, AlertTitle } from "@mui/material"
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useNavigate } from "react-router-dom";

import { useTranslation } from 'react-i18next';

import MainLayout from "../components/layout/Main"
import api from "../api"

function Account() {
  const [password, setPassword] = useState("")
  const [password2, setPassword2] = useState("")
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showError, setShowError] = useState(false)
  const [errorMessage, setErrorMessage] = useState([])
  const [loading, setLoading] = useState("")

  const navigate = useNavigate()

  const { t, i18n } = useTranslation()

  const error_index = {
    "This password is too short. It must contain at least 8 characters.": "account.password_too_short_error",
    "This password is too common.": "account.password_too_common",
    "The passwords do not match.": "account.passwords_do_not_match",
  }

  useEffect(() => {
    document.title = t("account.page_title")
  }, [])

  const handleSubmit = async (e) => {
    setLoading(true)
    try {
      const res = await api.post("/api/password/reset/", { "password": password, "password2": password2 })
    } catch (error) {
      setErrorMessage(error.response.data.data)
      setShowError(true)
    } finally {
      setLoading(false)
    }
  }

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
 
  return (
    <MainLayout activeComponent='/account'>
      <Card variant="outlined" sx={{ borderRadius: '16px' }} >
        <CardContent>
          <Typography variant="h4" sx={{ marginBottom: 2 }} >{t("account.password_reset_text")}</Typography>
          <Divider />
          <Alert variant="filled" severity="error" sx={{ marginTop: 2, display: showError ? '' : 'none' }}>
            <AlertTitle>{t("account.error_text")}</AlertTitle>
            {errorMessage.map((item) => <Typography>{t(error_index[item])}</Typography>)}
          </Alert>
          <Typography variant="h5" sx={{ marginTop: 2 }} >{t("account.enter_new_password_text")}</Typography>
          <FormControl variant="outlined" sx={{ width: '100%', marginTop: 1 }}>
            <InputLabel error={showError} htmlFor="outlined-adornment-password">{t("account.password_label")}</InputLabel>
            <OutlinedInput
              error={showError}
              id="password"
              type={showPassword ? 'text' : 'password'}    
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>}
              label={t("account.password_label")}
            />
          </FormControl>
          <Typography variant="h5" sx={{ marginTop: 1 }} >{t("account.repeat_password_text")}</Typography>
          <FormControl variant="outlined" sx={{ width: '100%', marginTop: 1 }}>
            <InputLabel error={showError} htmlFor="outlined-adornment-password">{t("account.password_label")}</InputLabel>
            <OutlinedInput
              error={showError}
              id="password2"
              type={showPassword2 ? 'text' : 'password'}    
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword2}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword2 ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>}
              label={t("account.password_label")}
            />
          </FormControl>
          <Box sx={{ display: 'flex', alignItems: 'end', justifyContent: 'end', marginTop: 2 }}>
            <Button variant="contained" onClick={handleSubmit} >
              {t("account.reset_password_button")}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </MainLayout>
  )
}

export default Account